import { Component, ViewEncapsulation, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIService } from '@app/cp/shared/services/DQOI.service';
import { AutoCompleteComponent } from '@progress/kendo-angular-dropdowns';
import { GItem } from '@app/cp/shared/models/GItem';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';

@Component({
    selector: 'customer-selector',
    templateUrl: './customer-selector.component.html',
    styleUrls: ['./customer-selector.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CustomerSelectorComponent {
    @ViewChild("searchAC") ac: AutoCompleteComponent;

    @Input() minSearchSize: number = 3;
    @Output() selected: EventEmitter<any> = new EventEmitter<any>();
    data: GItem[];
    constructor(globals: GlobalsService, private svc_data: DQOIService) {

    }

    private lastValueChanged: string;

    filterChange(filter: string) {
        if (filter.toString().length < this.minSearchSize) {
            this.data = [];
            return;
        }
        this.setLoading(true);

        this.svc_data.customer_Search(filter).subscribe((data: GItem[]) => {
            this.data = data;
            this.setLoading(false);
            //we need to do this to ensure any race condition
            if (this.lastValueChanged) {
                this.valueChange(this.lastValueChanged);
            }
        });
    }
    setLoading(loading: boolean) {
            this.ac.loading = loading;
    }
    valueChange(value: any) {
        if (CommonFunctions.hasValue(value)) {
            if (!this.data) {
                this.lastValueChanged = value;
                return;
            }
            this.lastValueChanged = null;
            let selectedItem = this.data.find(x => x.description == value);
            if (selectedItem) {
                this.svc_data.customerIdChanged(selectedItem.value);
                this.selected.emit(selectedItem.value);
            } else {
                this.svc_data.customerIdChanged(null);
                this.selected.emit(null);
            }
        }
        else {
            this.svc_data.customerIdChanged(null);
            this.selected.emit(null);
        }

    }
}
